import { CANVAS_TOOLS } from "../../../features/canvas/nativeCanvasElements";

export const TOOL_SHORTCUTS = Object.freeze({
  1: CANVAS_TOOLS.SELECT,
  2: CANVAS_TOOLS.RECTANGLE,
  3: CANVAS_TOOLS.DIAMOND,
  4: CANVAS_TOOLS.ELLIPSE,
  5: CANVAS_TOOLS.ARROW,
  7: CANVAS_TOOLS.DRAW,
  8: CANVAS_TOOLS.TEXT,
  a: CANVAS_TOOLS.ARROW,
  d: CANVAS_TOOLS.DIAMOND,
  h: CANVAS_TOOLS.HAND,
  o: CANVAS_TOOLS.ELLIPSE,
  p: CANVAS_TOOLS.DRAW,
  r: CANVAS_TOOLS.RECTANGLE,
  t: CANVAS_TOOLS.TEXT,
  v: CANVAS_TOOLS.SELECT,
});
